import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import { NgChartsModule } from 'ng2-charts';
import { SchoolDimissalFlowLogComponent } from './school-dimissal-flow-log/school-dimissal-flow-log.component';
import { DismissalProcessReportsComponent } from './dismissal-process-reports/dismissal-process-reports.component';
import { SharedModule } from '../shared/shared.module';
import { AttendanceReportsComponent } from './attendance-reports/attendance-reports.component';
import { DashboardService } from './_services/dashboard.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from '../_services/token-interceptor.service';
import { StudentAttendanceReportComponent } from './student-attendance-report/student-attendance-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportsControlBarComponent } from './reports-control-bar/reports-control-bar.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlModule } from 'ngx-owl-carousel';
import { CarouselModule } from 'ngx-owl-carousel-o';
// import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap'
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { CalendarModule } from 'primeng/calendar';
import { StudentsDismissalTrackingComponent } from './students-dismissal-tracking/students-dismissal-tracking.component';
import { StudentsTrackingComponent } from './students-tracking/students-tracking.component';
import { StudentsDismissalTrackingLogComponent } from './students-dismissal-tracking/students-dismissal-tracking-log/students-dismissal-tracking-log.component';
import { ViewStudentComponent } from './view-student/view-student.component';
import { OtpInterceptor } from '../_services/otp-interceptor.service';


@NgModule({
  declarations: [DashboardComponent, SchoolDimissalFlowLogComponent, DismissalProcessReportsComponent, AttendanceReportsComponent, StudentAttendanceReportComponent, ReportsControlBarComponent, StudentsDismissalTrackingComponent, StudentsTrackingComponent, StudentsDismissalTrackingLogComponent, ViewStudentComponent],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    NgChartsModule,
    SharedModule,
    MatMenuModule,
    MatTooltipModule,
    NgbTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    CalendarModule,
    // OwlModule,
    CarouselModule,
    MatIconModule
    // OwlDateTimeModule,
    // OwlNativeDateTimeModule
  ],
  providers: [
    DashboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, 
      useClass: OtpInterceptor, 
      multi: true
    }
  ],
})
export class ReportsModule { }
